import { Check } from "@phosphor-icons/react";

const features = [
  "Connect an unlimited number of LinkedIn accounts",
  "Send an unlimited number of LinkedIn campaigns",
  "Talk to an unlimited number of LinkedIn leads",
  "Scale your LinkedIn outreach",
];

export default function Features() {
  return (
    <ul className="flex flex-col gap-y-2">
      {features.map((feature) => (
        <li
          key={feature}
          className="flex w-max items-center gap-x-1 text-xs-medium lg:text-sm-medium"
        >
          <Check className="text-green-600" /> {feature}
        </li>
      ))}
    </ul>
  );
}
